import {createSlot} from '../../utils/react';

export const [
  DashboardPanelTitleSlotProvider,
  DashboardPanelTitleSlotArea,
  DashboardPanelTitleSlot,
] = createSlot();
